import { NETWORKS } from './constants'
import { CamelCase, LowerCase, PascalCase, UpperCase } from '../helpers/format.helpers'
import {
    basicClasses,
    advancedClasses,
    eliteClasses,
    exaltedClasses,
    PROFESSIONS_AR as professions,
} from './degenking'
import ListSubheader from '@mui/material/ListSubheader'
import MenuItem from '@mui/material/MenuItem'

const _toMenuItem = (label, value) => (
    <MenuItem key={value} value={value}>
        {label}
    </MenuItem>
)

const renderOptions = (array, casing) => {
    const format =
        casing === 'pascal'
            ? PascalCase
            : casing === 'camel'
            ? CamelCase
            : casing === 'lower'
            ? LowerCase
            : casing === 'upper'
            ? UpperCase
            : input => input

    return array.map(item => {
        const label = typeof item === 'string' ? format(item) : format(item.label)
        const value = typeof item === 'string' ? item : item.value
        return _toMenuItem(label, value)
    })
}

const ALL_OPTION = { label: 'all', value: '' }

const auctionTypes = [
    { label: 'sale', value: 'sale' },
    { label: 'rent', value: 'assisting' },
    { label: 'wallet', value: 'wallet' },
]

const networks = [
    { label: 'Crystalvale', value: NETWORKS.dfkchain.id },
    { label: 'Serendale 2', value: NETWORKS.klaytn.id },
]

const rarities = [
    { label: 'common', value: '0' },
    { label: 'uncommon', value: '1' },
    { label: 'rare', value: '2' },
    { label: 'legendary', value: '3' },
    { label: 'mythic', value: '4' },
]

const walletHeroesSort = [
    { label: 'ID', value: 'id' },
    { label: 'Gen', value: 'generation' },
    { label: 'Level', value: 'level' },
    { label: 'Main Class', value: 'mainClass' },
    { label: 'Profession', value: 'profession' },
    { label: 'Rarity', value: 'rarity' },
]

export const auctionTypeOptions = renderOptions(auctionTypes)

export const networkOptions = renderOptions(networks)

const buildOptions = (input, includeAllOption, allOverride) => {
    const options = [...input]

    if (includeAllOption) {
        const allOption = allOverride ? allOverride : ALL_OPTION
        options.unshift(allOption)
    }

    return options
}

export const professionOptions = (includeAllOption, allOverride, casing) => {
    const options = buildOptions(professions, includeAllOption, allOverride)
    return renderOptions(options, casing)
}

export const rarityOptions = (includeAllOption, allOverride, casing) => {
    const options = buildOptions(rarities, includeAllOption, allOverride)
    return renderOptions(options, casing)
}

export const walletHeroesSortOptions = renderOptions(walletHeroesSort)

// Renders the list of options for the Summon Class dropdown
const menuoptions = list => list.sort().map(name => (
    <MenuItem key={name} value={name}>
        {name}
    </MenuItem>
))

const basic = menuoptions(basicClasses)
const advanced = menuoptions(advancedClasses)
const elite = menuoptions(eliteClasses)
const exalted = menuoptions(exaltedClasses)

export const classOptions = (includeAllOption, allOverride) => {
    const options = [
        <ListSubheader key="basic">Basic Classes</ListSubheader>,
        ...basic,
        <ListSubheader key="advanced">Advanced Classes</ListSubheader>,
        ...advanced,
        <ListSubheader key="elite">Elite Classes</ListSubheader>,
        ...elite,
        <ListSubheader key="exalted">Exalted Classes</ListSubheader>,
        ...exalted,
    ]

    const all = renderOptions(buildOptions([], includeAllOption, allOverride))

    return all.length ? [all, ...options] : options
}
